import React, { Component } from "react";
import ReCaptcha from "../common/recaptcha.component";
import { forgotPassword } from "../../services/rest";
import Validator from "../../utils/Validator";
import { USERNAME_VALIDATION_ERROR_MESSAGE } from "../../utils/constants";
import ErrorHandler from "../../utils/error-handler";
import TaggingHelper from "../../tagging/tagging-helper";

class ForgotPassword extends Component {

  defaultUserName = this.props.data?.username || '';

  defaultState = {
    isUsernameValid: Validator.isValidUsername(this.defaultUserName),
    token: null,
    username: this.defaultUserName,
    usernameActive: false
  };

  constructor(props) {
    super(props);
    if (props.data && props.data.previousState) {
      this.state = {
        ...props.data.previousState,
        token: null
      };
    } else {
      this.state = this.defaultState;
    }
  }

  componentDidMount() {
    TaggingHelper.forgotPasswordLandingEvent();
  }

  onUsernameChange = (e) => {
    this.setState({
      username: e.target.value,
      isUsernameValid: Validator.isValidUsername(e.target.value)
    });
  };

  _onVerifyCallback = (token) => {
    this.setState({
      token: token
    });
  };

  activateField = (e) => {
    this.setState({
      [`${e.target.name}Active`]: true
    });
  };

  disableField = (e) => {
    this.setState({
      [`${e.target.name}Active`]: false
    });
  };

  _onExpiredCallback = () => {
    this.setState({ token: null });
  };

  sendtOtp = (e) => {
    e.preventDefault();
    const { goto } = this.props;
    this.props.showUILoader(true);
    forgotPassword(this.state.username, this.state.token)
      .then((response) => {
        if (response.data && response.data.result && response.status === 200) {
          const message = response.data.result.message || "";
          goto("FORGOT_PASSWORD_OTP", {
            message,
            currentState: this.state
          });
        } else {
          throw new Error("UNEXPECTED_ERROR");
        }
      })
      .catch((error) => {
        ErrorHandler.handleForgotPasswordOtpRequestApiError(
          error,
          goto,
          this.state,
          "FORGOT_PASSWORD"
        );
        const errorMessage = ErrorHandler.getErrorMessage(error).errorMessage;
        TaggingHelper.forgotPasswordErrorEvent(errorMessage);
      })
      .finally(() => {
        this.props.showUILoader(false);
      });
  };

  onGoBack = () => {
    this.props.goto("LOGIN");
  };

  render() {
    const { goto } = this.props;
    const { usernameActive, username, isUsernameValid, token } = this.state;
    return (
      <React.Fragment>
        <div className="card-header">
          <h2>Forgot Password</h2>
          <p>
            {"Don't have an account yet? "}
            <button
              type="button"
              className="button-link"
              onClick={() => goto("CREATE_PROFILE")}
              automationid="LOGIN_FORM_FORGOTPASSWORD_1"
            >
              {`  Register now `}
            </button>
          </p>
        </div>
        <div className="field-group">
          <label className={usernameActive || username ? "active" : ""}>
            {"Cell number or email/username"}
          </label>
          <input
            onChange={this.onUsernameChange}
            value={username}
            type="text"
            name="username"
            required
            onFocus={this.activateField}
            onBlur={this.disableField}
            automationid="LOGIN_FORM_FORGOTPASSWORD_2"
            className={
              !usernameActive && username && !isUsernameValid ? "error" : ""
            }
          />
          {!usernameActive && username && !isUsernameValid && (
            <p className="infield-error-label">
              {USERNAME_VALIDATION_ERROR_MESSAGE}
            </p>
          )}
        </div>
        <div className="captcha-wrapper forgot-uname-captcha-wrapper">
          <ReCaptcha
            sitekey={"6LdNAAwUAAAAALEhZyYgkqFtXUPKVhD5Fj2XaWUm"}
            verifyCallback={this._onVerifyCallback}
            expiredCallback={this._onExpiredCallback}
          />
        </div>
        <div className="action-button-wrapper">
          <button
            type="submit"
            className="btn btnRed"
            disabled={!token || !isUsernameValid}
            onClick={(e) => this.sendtOtp(e)}
            automationid="LOGIN_FORM_FORGOTPASSWORD_4"
          >
            SEND OTP
          </button>
        </div>
        <div className="action-button-wrapper">
          <button
            type="button"
            className="btn btnWhite"
            onClick={this.onGoBack}
            automationid="LOGIN_FORM_FORGOTPASSWORD_3"
          >
            LOGIN WITH PASSWORD
          </button>
        </div>
      </React.Fragment>
    );
  }
}

export default ForgotPassword;
